<!-- Decoración ilustrada que se carga desde /img, sin interferir con los enlaces -->
<div class="iguau-footer-decoracion no-imprimir" aria-hidden="true">
  <img [src]="imgDecoracion" alt="" loading="lazy" decoding="async">
</div>
<footer class="iguau-footer no-imprimir" aria-label="Pie de página de iGuau">
  <div class="footer-inner container">
    <div class="footer-main">
      <div class="footer-brand">
        <a class="footer-logo" [href]="global.urlServer" aria-label="iGuau, ir al inicio">
          <img [src]="imglogo" alt="iGuau" loading="lazy">
        </a>
        <p class="footer-description">Un lugar para compartir momentos, descubrir nuevos amigos y vivir grandes aventuras con tus mascotas.</p>
        <div class="footer-social" aria-label="Redes sociales">
          <a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" aria-label="Facebook de iGuau" title="Facebook"><i class="fa-brands fa-facebook-f" aria-hidden="true"></i></a>
          <a href="https://www.instagram.com/iguau/" target="_blank" rel="noopener noreferrer" aria-label="Instagram de iGuau" title="Instagram"><i class="fa-brands fa-instagram" aria-hidden="true"></i></a>
        </div>
      </div>

      <nav class="footer-column" aria-label="Enlaces de cuenta">
        <h2>Tu espacio</h2>
        <ul>
          <ng-container *ngIf="!misdatos?.ID; else loggedLinks">
            <li><a [href]="global.urlServer + 'login'">Iniciar sesión</a></li>
            <li><a [href]="global.urlServer + 'register'">Crear una cuenta</a></li>
          </ng-container>
          <ng-template #loggedLinks>
            <li><a [href]="global.urlServer + 'perfil'">Mi perfil</a></li>
            <li><a [href]="global.urlServer + 'opciones'">Opciones</a></li>
            <li *ngIf="misdatos?.rol === 'administrator'"><a [href]="global.urlServer + 'wp-admin'" target="_blank" rel="noopener noreferrer">Administración</a></li>
          </ng-template>
        </ul>
      </nav>

      <nav class="footer-column" aria-label="Enlaces de información">
        <h2>Información</h2>
        <ul>
          <li><a [href]="global.urlServer + 'faq'">Preguntas frecuentes</a></li>
          <li><a [href]="global.urlServer + 'politica-privacidad'">Política de privacidad</a></li>
          <li><a [href]="global.urlServer + 'terminos-legales'">Términos legales</a></li>
          <li><a [href]="global.urlServer + 'politica-cookies'">Política de cookies</a></li>
        </ul>
      </nav>

      <div class="footer-column footer-contact">
        <h2>Hablemos</h2>
        <p>¿Tienes alguna duda o sugerencia? Estamos aquí para ayudarte.</p>
        <a class="contact-link" href="mailto:info@iguau.es"><i class="fa-regular fa-envelope" aria-hidden="true"></i> info&#64;iguau.es</a>
      </div>
    </div>

    <div class="footer-bottom">
      <span>© {{anyo}} iGuau. Todos los derechos reservados.</span>
      <span class="footer-bottom-brand"><i class="fa-solid fa-paw" aria-hidden="true"></i> Hecho para quienes aman a los animales</span>
    </div>
  </div>
</footer>
